import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class PaymentOrderIncomeReceiptReportLine  {
    _originalTypeClassName = "zERP.BO.PaymentOrderIncomeReceiptReportLine";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
PaymentOrderIncomeReceiptReportLine.translate = translateService;
}
this.Code = null;
this.Cashier = null;
this.Register = null;
this.Trader = null;
this.Description = null;
this.AccountingAccount = null;
this.PaymentMethod = null;
this.Amount = null;
this.CheckNumber = null;
this.BankAccount = null;
this.GroupBy = null;
this.Date = null;
this.PaymentOrderIncomeReceiptReportLineKey = null;
this._key = this.PaymentOrderIncomeReceiptReportLineKey = 0; 
}

static translate: TranslateService;
_key: any;
Code:any;
Cashier:any;
Register:any;
Trader:any;
Description:any;
AccountingAccount:any;
PaymentMethod:any;
Amount:any;
CheckNumber:any;
BankAccount:any;
GroupBy:any;
Date:any;
private _PaymentOrderIncomeReceiptReportLineKey:any;
get PaymentOrderIncomeReceiptReportLineKey(): any {
    return this._PaymentOrderIncomeReceiptReportLineKey;
  }
set PaymentOrderIncomeReceiptReportLineKey(value: any) {
    this._PaymentOrderIncomeReceiptReportLineKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.PaymentOrderIncomeReceiptReportLineKey == null || $this.PaymentOrderIncomeReceiptReportLineKey == 0;
            }


}